<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.generalInformationTitle')">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$labels.surface_habitable + ' *'"
                                      prop="surface_habitable"
                                      >
                            <el-input  v-model="post.surface_habitable" type="number" step="0.01">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$labels.surface_utile"
                                      prop="surface_utile"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.surface_utile" type="surface_utile">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$labels.surface_terrain"
                                      prop="surface_terrain"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.surface_terrain" type="surface_terrain">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.modele_maison">
                            <el-input v-model="post.modele_maison">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.marque_maison">
                            <el-input v-model="post.marque_maison">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.gamme_modele_maison">
                            <el-input v-model="post.gamme_modele_maison">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.houseTitle')">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$labels.nb_pieces_logement"
                                      prop="nb_pieces_logement"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.nb_pieces_logement" type="nb_pieces_logement">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$labels.nombre_de_chambres"
                                      prop="nombre_de_chambres"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.nombre_de_chambres" type="nombre_de_chambres">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$labels.nombre_niveaux"
                                      prop="nombre_niveaux"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.nombre_niveaux" type="nombre_niveaux">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="$labels.surface_sejour"
                                      prop="surface_sejour"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.surface_sejour" type="surface_sejour">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.mitoyennete}} <el-button class="el-icon-error reset-radio"
                                                                               v-if="post.mitoyennete != '' && post.mitoyennete != undefined && post.mitoyennete != null"
                                                                               @click="post.mitoyennete = null"
                                                                               circle></el-button></div>
                            <el-radio-group v-model="post.mitoyennete">
                                <el-radio
                                        v-for="mitoyenneteChoice in this.$parent.getChoices('mitoyennete')"
                                        :label="mitoyenneteChoice"
                                        :value="mitoyenneteChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.chauffage_energie">
                            <el-select
                                    v-model="post.chauffage_energie"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_energie')"
                                        :key="energieChauffageChoice"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.eau_chaude_distribution }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.eau_chaude_distribution != '' && post.eau_chaude_distribution != undefined && post.eau_chaude_distribution != null"
                                           @click="post.eau_chaude_distribution = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.eau_chaude_distribution">
                                <el-radio
                                        v-for="eauChaudeDistributionChoice in this.$parent.getChoices('eau_chaude_distribution')"
                                        :label="eauChaudeDistributionChoice"
                                        :value="eauChaudeDistributionChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="$labels.garage">
                            <el-radio v-model="post.garage" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.garage" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="post.garage == 'oui'">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.garage_emplacement }} <el-button class="el-icon-error reset-radio"
                                                                                 v-if="post.garage_emplacement != '' && post.garage_emplacement != undefined && post.garage_emplacement != null"
                                                                                 @click="post.garage_emplacement = null"
                                                                                 circle></el-button></div>
                            <el-radio-group v-model="post.garage_emplacement">
                                <el-radio
                                        v-for="typeGarageChoice in this.$parent.getChoices('garage_emplacement')"
                                        :label="typeGarageChoice"
                                        :value="typeGarageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="$labels.facade_construction_max"
                                      prop="facade_construction_max"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.facade_construction_max" type="facade_construction_max">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$labels.hauteur_maximum"
                                      prop="hauteur_maximum"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.hauteur_maximum" type="hauteur_maximum">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.style_construction">
                            <el-select
                                    v-model="post.style_construction"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="styleConstructionChoice in this.$parent.getChoices('style_construction')"
                                        :key="styleConstructionChoice"
                                        :label="styleConstructionChoice"
                                        :value="styleConstructionChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="23">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.type_construction}} <el-button class="el-icon-error reset-radio"
                                            v-if="post.type_construction != '' && post.type_construction != undefined && post.type_construction != null"
                                            @click="post.type_construction = null"
                                            circle></el-button></div>
                            <el-radio-group v-model="post.type_construction">
                                <el-radio
                                        v-for="typeConstructionChoice in this.$parent.getChoices('type_construction')"
                                        :label="typeConstructionChoice"
                                        :value="typeConstructionChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.type_livraison}} <el-button class="el-icon-error reset-radio"
                                                                                          v-if="post.type_livraison != '' && post.type_livraison != undefined && post.type_livraison != null"
                                                                                          @click="post.type_livraison = null"
                                                                                          circle></el-button></div>
                            <el-radio-group v-model="post.type_livraison">
                                <el-radio
                                        v-for="typeLivraisonChoice in this.$parent.getChoices('type_livraison')"
                                        :label="typeLivraisonChoice"
                                        :value="typeLivraisonChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.landTitle')">
                <el-row :gutter="24">
                    <el-col :span="24">
                        <el-form-item :label="$labels.longueur_terrain"
                                      prop="longueur_terrain"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.longueur_terrain" type="longueur_terrain">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.largeur_terrain"
                                      prop="largeur_terrain"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.largeur_terrain" type="largeur_terrain">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.land')">
                            <el-checkbox v-model="post.avec_pente" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandWithSlope") }}</el-checkbox>
                            <el-checkbox v-model="post.viabilise" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandServiced") }}</el-checkbox>
                            <el-checkbox v-model="post.lotissement" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandAllotment") }}</el-checkbox>
                            <el-checkbox v-model="post.constructible" true-label="oui" false-label="non">{{$t("posts.edit.checkboxLandBuildable") }}</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$labels.exposition">
                                <el-select
                                        v-model="post.exposition"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                            :key="expositionChoice"
                                            :label="expositionChoice"
                                            :value="expositionChoice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <div style="font-size: 12px;">{{ $t("posts.edit.location") }} <el-button class="el-icon-error reset-radio"
                                                                                   v-if="post.environnement != '' && post.environnement != undefined && post.environnement != null"
                                                                                   @click="post.environnement = null"
                                                                                   circle></el-button></div>
                                <el-radio-group v-model="post.environnement">
                                    <el-radio
                                            v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                            :label="environnementChoice"
                                            :value="environnementChoice">
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.locationProximityAndSituation')">
                                <el-checkbox
                                        v-model="post.proche_aeroport"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxAirport") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_sortie_autoroute"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxHighwayExit") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_gare"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxGare") }}
                                </el-checkbox>
                                <el-checkbox v-model="post.proche_bus" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxBus") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_tram"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxTramway") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_parking"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxParking") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_commerces"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxShops") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_centre_commercial"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxMall") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_centre_ville"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxDowntown") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_creche"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxNursery") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_ecole_primaire"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxPrimarySchool") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_college"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxCollege") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_lycee"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxHighSchool") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_universite"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxUniversity") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.espaces_verts"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxGreenSpaces") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_metro"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxSubway") }}
                                </el-checkbox>
                                <el-checkbox v-model="post.belle_vue" true-label="oui" false-label="non">{{$labels.belle_vue}}</el-checkbox>
                                <el-checkbox
                                        v-model="post.vue_sur_mer"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $labels.vue_sur_mer }}</el-checkbox>
                                <el-checkbox v-model="post.est_calme"
                                             true-label="oui"
                                             false-label="non"
                                >{{ $labels.est_calme }}</el-checkbox>
                                <el-checkbox
                                        v-model="post.avec_vis_a_vis"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $labels.avec_vis_a_vis }}</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="$labels.shon"
                                          prop="shon"
                                          >
                                <el-input  v-mask="'#################'" v-model.number="post.shon" type="shon">
                                    <template slot="append">m²</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$labels.cos"
                                          prop="cos"
                                          >
                                <el-input type="number" v-model="post.cos" step="0.01">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.propertyPartnerTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerCompany')">
                            <el-input v-model="post.partenaire_foncier_societe">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$t('posts.edit.propertyPartnerLastname')">
                            <el-input v-model="post.partenaire_foncier_nom">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('posts.edit.propertyPartnerFirstname')">
                            <el-input v-model="post.partenaire_foncier_prenom">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('posts.edit.propertyPartnerPhone')">
                            <el-input v-model="post.partenaire_foncier_telephone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.labelsAndCertificationsTitle')">
                <el-row :gutter="20">
                    <el-col :span="12"><el-checkbox v-model="post.label_nf_maison_individuelle" true-label="oui" false-label="non">{{$labels.label_nf_maison_individuelle}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_hqe" true-label="oui" false-label="non">{{$labels.label_hqe}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.re_2020" true-label="oui" false-label="non">{{$labels.re_2020}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_thpe" true-label="oui" false-label="non">{{$labels.label_thpe}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_he" true-label="oui" false-label="non">{{$labels.label_he}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_he_effinergie" true-label="oui" false-label="non">{{$labels.label_he_effinergie}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_qualibat" true-label="oui" false-label="non">{{$labels.label_qualibat}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_acermi" true-label="oui" false-label="non">{{$labels.label_acermi}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_ce" true-label="oui" false-label="non">{{$labels.label_ce}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_promotelec" true-label="oui" false-label="non">{{$labels.label_promotelec}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_maison_de_qualite" true-label="oui" false-label="non">{{$labels.label_maison_de_qualite}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_maison_de_confiance" true-label="oui" false-label="non">{{$labels.label_maison_de_confiance}}</el-checkbox></el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <dpe-ges :post="post"></dpe-ges>
        <securite-bien :post="post"></securite-bien>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import { SwitchButton } from '../../../../components/forms/SwitchButton'
import ElButton from '../../../../components/Button'
import DpeGes from '../Block/DpeGes'
import SecuriteBien from "@/pages/posts/forms/Block/SecuriteBien.vue";

export default {
  name: 'PostEditImmoObject5200',
  components: {SecuriteBien, ElButton, DpeGes },
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = ['mitoyennete', 'exposition', 'chauffage_energie', 'style_construction', 'type_construction', 'type_livraison', 'garage_emplacement', 'exposition', 'environnement', 'mandat_statut', 'modalites_recuperation_charges_locatives', 'eau_chaude_distribution']

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)

    for (let i = this.$parent.getChoices('mitoyennete').length - 1; i >= 0; i--) {
      if (this.$parent.getChoices('mitoyennete')[i] === 'oui') {
        this.$parent.getChoices('mitoyennete').splice(i, 1)
      }
    }
  }
}
</script>

<style>
    .reset-radio {
        font-size: 20px;
        color: lightgrey;
        border: none;
    }
</style>
